import request from '../../../../request/request';

const getIncompleteProjects = () => {
  return request({
    url: '/webapi/project/report/incomplete-project'
  });
};

const sendNotification = ({ mails }) => {
  return request({
    url: `/webapi/notification/message/send`,
    method: 'POST',
    data: { mails }
  });
};

export { getIncompleteProjects, sendNotification };
